<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">رنج سنی مورد نظر</h4>
    </div>
    <div class="card-body d-flex justify-content-around">
      <div class="form-check" v-for="(ageRange, index) in ageRanges" :key="index">
        <input
            class="form-check-input"
            type="radio"
            :id="index"
            :value="ageRange"
            v-model="jobQualification.age_range"
        />
        <label class="form-check-label" :for="index">{{ ageRange }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ageRanges: {
        ageRange1: '18-25',
        ageRange2: '26-35',
        ageRange3: 'فرقی ندارد',
      }
    }
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    }
  }
};
</script>
